const CACHED_SEARCH_DATA_KEY = 'cached_search';

export const cacheLastSearchResult = (url: string) => {
    localStorage.setItem(CACHED_SEARCH_DATA_KEY, url);
}

export const clearLastSearchResult = () => localStorage.removeItem(CACHED_SEARCH_DATA_KEY);

export const getLastCachedSearchResultValue = () => localStorage.getItem(CACHED_SEARCH_DATA_KEY);